import { render, staticRenderFns } from "./PuzzleForm.vue?vue&type=template&id=5663c413&scoped=true&"
import script from "./PuzzleForm.vue?vue&type=script&lang=js&"
export * from "./PuzzleForm.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleForm.vue?vue&type=style&index=0&id=5663c413&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5663c413",
  null
  
)

export default component.exports